export enum CookieConsentLevelsEnum {
  /** Technical cookies help to make a website usable by enabling basic
   * functions like page navigation and access to secure areas of the website.
   * The website cannot function properly without these cookies. */
  TECHNICAL = 1,
  /** Analytics cookies help website owners to understand how visitors
   * interact with websites by collecting and reporting information anonymously. */
  ANALYTICAL = 2,
  /** Preference cookies enable a website to remember information that changes
   * the way the website behaves or looks, like your preferred language or the
   * region that you are in. */
  PREFERENCE = 3,
  /** Marketing cookies are used to track visitors across websites. The intention
   * is to display ads that are relevant and engaging for the individual user and
   * thereby more valuable for publishers and third party advertisers.
   * */
  MARKETING = 4
}
